var angular = require('angular');
var _ = require('underscore');
var CategoryAPI = require('../../api').CharitableCategories;

module.exports = function($scope, options)
{
  $scope.selectedCategories = angular.copy(options.value) || [];

  $scope.cancel = function(){
    $scope.closeThisDialog({action:'cancel'});
  }

  $scope.save = function(){
    $scope.closeThisDialog({action:'save',value:$scope.selectedCategories});
  }

}
